module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "blood-glucose-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "horizontal",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.latestReadingTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.value + ' ' + _vm.data.measure)
    }
  }), _vm._v(" "), (_vm.data.userDevice && _vm.data.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('From device: ' + _vm.data.userDevice.nickname),
      expression: "'From device: ' + data.userDevice.nickname",
      modifiers: {
        "left": true
      }
    }],
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "margin-left": "4px"
    },
    attrs: {
      "width": "22",
      "src": "/static/ic_devices_bg@3x.png"
    }
  })]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lastReadingAtTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.data.date))
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.inRangeTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.in_range_today)
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.averageTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.average + ' ' + _vm.data.measure)
    }
  }), _vm._v(" "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "14px",
      "height": "16px",
      "viewBox": "26 191 11 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.3873266,202.013826 C36.3873266,201.047215 36.0280503,199.003253 34.5350319,197.082478 C33.2459103,195.424041 31.1433712,191 31.1433712,191 C31.1433712,191 29.1414164,195.424041 27.8522947,197.082448 C26.3592763,199.003223 26,201.047186 26,202.013826 C26,204.564452 28.2936491,206.63741 31.1433712,206.685209 L31.1433712,206.686322 C31.1601681,206.686322 31.1768993,206.685883 31.1936633,206.685766 C31.2104602,206.685912 31.2271914,206.686322 31.2439883,206.686322 L31.2439883,206.685209 C34.0936775,206.63741 36.3873266,204.564452 36.3873266,202.013826 L36.3873266,202.013826 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#E74C3C",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), (_vm.data.no_setting) ? _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen || _vm.loading
    },
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": "settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.open.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.data.no_setting) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.isOpenInput ? _vm.$t('message.closeText') : _vm.$t('message.addEntryText')),
      expression: "isOpenInput ? $t('message.closeText') : $t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isOpen && _vm.data.no_setting) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [(_vm.data.missing_settings.blood_glucose) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "blood_glucose_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Blood glucose settings",
      "errorText": _vm.errors.first('blood_glucose_setting'),
      "label": "BLOOD GLUCOSE MEASUREMENT",
      "fullWidth": true,
      "scroller": _vm.scroller,
      "separator": ", "
    },
    model: {
      value: (_vm.settings.blood_glucose),
      callback: function($$v) {
        _vm.$set(_vm.settings, "blood_glucose", $$v)
      },
      expression: "settings.blood_glucose"
    }
  }, _vm._l((_vm.data.missing_settings.blood_glucose), function(item, index) {
    return _c('mu-menu-item', {
      key: 'blood-glucose-setting-' + item,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.glucose_range) ? _c('div', [_c('vue-slider', _vm._b({
    model: {
      value: (_vm.sliderSettings.value),
      callback: function($$v) {
        _vm.$set(_vm.sliderSettings, "value", $$v)
      },
      expression: "sliderSettings.value"
    }
  }, 'vue-slider', _vm.sliderSettings, false))], 1) : _vm._e(), _vm._v(" "), (_vm.data.missing_settings.hba1c) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "hba1c_setting",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "hbA1c settings",
      "errorText": _vm.errors.first('hba1c_setting'),
      "label": "HBA1C MEASUREMENT",
      "fullWidth": true,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.settings.hba1c),
      callback: function($$v) {
        _vm.$set(_vm.settings, "hba1c", $$v)
      },
      expression: "settings.hba1c"
    }
  }, _vm._l((_vm.data.missing_settings.hba1c), function(item, index) {
    return _c('mu-menu-item', {
      key: 'hba1c-setting-' + item,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveSettings.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onEnter,
      "leave": _vm.onLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.bloodGlucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "540",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:540',
      "data-vv-as": "mg/dL",
      "data-vv-name": "mgdl",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mgdl'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mgdl", _vm._n($$v))
      },
      expression: "model.blood_glucose_mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "30",
      "data-vv-validate-on": "none",
      "data-vv-as": "mmol/L",
      "data-vv-rules": 'min_value:0|max_value:30',
      "data-vv-name": "mmoll",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mmoll'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mmoll", _vm._n($$v))
      },
      expression: "model.blood_glucose_mmoll"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "25",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": "%",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_percent", _vm._n($$v))
      },
      expression: "model.hba1c_percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "300",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_mmol_mol", _vm._n($$v))
      },
      expression: "model.hba1c_mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "label": _vm.$t('message.labelTagYourReading'),
      "fullWidth": true,
      "maxHeight": 300,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.model.tag),
      callback: function($$v) {
        _vm.$set(_vm.model, "tag", $$v)
      },
      expression: "model.tag"
    }
  }, _vm._l((_vm.readingTags), function(tag, index) {
    return _c('mu-menu-item', {
      key: 'reading-tag' + index,
      attrs: {
        "value": tag,
        "title": _vm.$t(_vm.localizeTag(tag.tag))
      }
    })
  }), 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b26c018","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/BloodGlucose/BloodGlucose.vue
// module id = 3653
// module chunks = 1